@if (highlightedHtml(); as html) {
  <pre class="code-snippet"><code [innerHTML]="html"></code></pre>
} @else {
  <pre class="code-snippet"><code>{{ code() }}</code></pre>
}
